module.exports = __webpack_public_path__ + "img/gold-right.dd0fe006.png";